/**
 * @module メールメッセージ共通コンポーネント
 */
export default {
  name: 'EmailMessenger',
  components: {},
  props: {
    page: {
      type: Number,
    },
  },
  data() {
    return {
      mailDomain: '',
      info1: '',
      info2: '',
      info3: '',
      info4: '',
      info5: '',
    };
  },
  computed: {
    i18nItems() {
      return {
        info1: this.getContents(this.page).info1,
        info2: this.getContents(this.page).info2,
        info3: this.getContents(this.page).info3,
        info4: this.getContents(this.page).info4,
        info5: this.getContents(this.page).info5,
      };
    },
  },
  mounted() {
    const url = new URL(window.location.href);
    this.mailDomain = url.hostname.replace('www.', '');
  },
  /** @type {Methods} */
  methods: {
    /**
     * 表示メッセージ情報を取得
     * @param {number} page ページ番号
     * @returns getInfos メール情報
     */
    getContents: function (page) {
      switch (page) {
        case 52: {
          return this.getInfos(
            '【HOME ALSOK】ユーザー登録',
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.本登録'
          );
        }
        case 4: {
          return this.getInfos(
            '【HOME ALSOK】パスワード初期化',
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.パスワード設定'
          );
        }
        case 40: {
          return this.getInfos(
            '【HOME ALSOK】 対象地区ニックネーム/カメラニックネーム のメインユーザー移譲確認',
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.承認否認操作'
          );
        }
        case 48: {
          return this.getInfos(
            '【HOME ALSOK】ユーザー情報変更確認',
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.承認否認操作'
          );
        }
        default: {
          return {
            info1: '',
            info2: '',
            info3: '',
            info4: '',
            info5: '',
          };
        }
      }
    },
    /**
     * メール情報配列を取得
     * @param {String} mailTitle
     * @param {String} info2VuetifyTextTemplate
     * @returns array メール情報配列
     */
    getInfos: function (mailTitle, info2VuetifyTextTemplate) {
      return {
        info1: this.getInfo1(mailTitle),
        info2: this.getInfo2(info2VuetifyTextTemplate),
        info3: this.getInfo3(),
        info4: this.getInfo4(mailTitle),
        info5: this.getInfo5(),
      };
    },
    /**
     * タイトル文字列の取得
     * @param {String} mailTitle
     * @returns string タイトル文字列
     */
    getInfo1: function (mailTitle) {
      return this.$vuetify.lang.t(
        '$vuetify.FECU54Thanks画面.ご登録いただいているメールアドレスに',
        mailTitle
      );
    },
    /**
     * 本文文字列取得
     * @param {String} vuetifyTextTemplate
     * @returns strinf 本文文字列
     */
    getInfo2: function (vuetifyTextTemplate) {
      return this.$vuetify.lang.t(vuetifyTextTemplate, this.getDefaultValidPeriod());
    },
    /**
     * メール受信注意文字列取得
     * @returns string メール受信注意文字列
     */
    getInfo3: function () {
      return (
        this.$vuetify.lang.t(
          '$vuetify.FECU54Thanks画面.メールが届かない場合は以下の可能性が考えられます'
        ) +
        this.$vuetify.lang.t(
          '$vuetify.FECU54Thanks画面.メールの設定を変更後再度操作を行ってください'
        )
      );
    },
    /**
     * 迷惑メール文字列取得
     * @param {String} mailTitle
     * @returns string 迷惑メール文字列
     */
    getInfo4: function (mailTitle) {
      return (
        this.$vuetify.lang.t(
          '$vuetify.FECU54Thanks画面.迷惑メールとして処理されている可能性があります'
        ) +
        this.$vuetify.lang.t('$vuetify.FECU54Thanks画面.迷惑メールフォルダやゴミ箱等に') +
        mailTitle +
        this.$vuetify.lang.t('$vuetify.FECU54Thanks画面.という件名のメール') +
        this.$vuetify.lang.t('$vuetify.FECU54Thanks画面.がないかご確認をお願いいたします')
      );
    },
    /**
     * ドメイン指定注意文字列取得
     * @returns string ドメイン指定注意文字列
     */
    getInfo5: function () {
      return this.$vuetify.lang.t(
        '$vuetify.FECU54Thanks画面.ドメイン指定を行っている方は',
        `@${this.mailDomain}`
      );
    },
    getDefaultValidPeriod: function () {
      return 60;
    },
  },
};
